export const CREATE_INQUIRY = '/createinquiry'
export const DUEOUT = '/createdueout'
export const DUEOUTS = '/dueouts'
export const INQUIRIES = '/inquiries'
export const MY_INQUIRIES = '/myinquiries-dueouts'
export const ROUTE_TYPE = '/'
export const PROFILE = '/profile'
export const RHYBUS_ACCESS_TOKEN='rhybustoken'
export const RHYBUS_REFRESH_TOKEN='rhybusrefreshtoken'
export const APP_NAME='Anew-TRM'
export const CLIENT_CODE='clientcode'
export const MSAL_ACC='msal-acc'
export const SessionTimeOut = 20*60*2000
export type AuthMode = "msal" | "otp" | "keycloak" | "none";
export const OTP_LOGIN='otplogin'
export const USER_CODE_KEY='usercodeKey'
export const USER_ACTIVITY='user-activity'
export const USER_EMAIL_MOBILE_KEY='userId'
export const USER_EMAIL_OR_MOBILE_KEY='useremailmobilekey'
export const USER_MOBILE_KEY='usermobilekey'
export const USER_LOGIN_SESSIONID='X-User-Session-Id'



export const MAX_NUM_FILES = 10
export const ACCEPTABLE_FILE_TYPES = [
  'xlsx', 'xls', 'doc', 'docx', 'ppt', 'pptx',
  'txt', 'pdf', 'png', 'jpg', 'jpeg', 'gif', 'msg'
]
export const SELECT_MESSAGE = 'Please select'
export const SELECT = 'Select'
export const ENTER_MSG = 'Please enter'
export const SELECT_DATE = 'Please select date'
export const ENTER_MAIL_ID = 'Please eneter valid mail ID'
export const NORESULT = 'There are no results to display'
export const FILENAME_REGEX = /['~#%{}+]|\\.\\.|^\\.|\\.$/
export const UPDATE_ALERT = 'No Changes Detected'
export const COMMENT_TO_IN_DISCUSSIONS  = true
export const DELETE_MSG = 'Are you sure, you want to delete the selected item?'
export const CONCURRENCY_ERRMSG ='Concurrency error! Please click OK to reload the page.'
export const FILE_HINT_MSG = 'Upload the files which are in the .xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf, .png, .jpg, .jpeg, .gif, .msg and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen.'
export const AUTO_FILL_HINT_MSG = 'Upload vehicle, title, insurance, or supporting documents (.xlsx, .xls, .doc, .docx, .txt, .pdf, .png, .jpg, .jpeg) to automatically extract and pre-fill inquiry information. Maximum size for file is 25 MB.'
export const BULK_IMPORT_FILE_HINT_MSG = 'Upload the files which are in the .xlsx, .xls and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 1 files per screen.'
export enum DiscussionType {
  PUBLIC = 'Public',
  PRIVATE = 'Internal'
}

export const IMPORT_HEADERS = [
    "VIN",
    "Account Name",
    "Sub-Client Name",
    "Account / Sub-Client FEIN",
    "Account / Sub-client Tax Exempt Number",
    "Point of Contact",
    "Email",
    "Phone Number",
    "Account Owner",
    "Account Address",
    "Account Unit/Suite Number",
    "Account City",
    "Account County",
    "Account State",
    "Account Zipcode",

    "Register To",
    "Register Address",
    "Register Unit/Suite Number",
    "Register City",
    "Register County",
    "Register State",
    "Register Zipcode",

    "Title To",
    "Title Address",
    "Title Unit/Suite Number",
    "Title City",
    "Title County",
    "Title State",
    "Title Zipcode",

    "Process Type",
    "Processing State",
    "Processing County",

    "Year",
    "Make",
    "Model",
    "Gross Vehicle Weight",
    "EVW",
    "Ownership Type",
    "Plate Type",
    "Fuel Type",
    "Odometer",

    "Lien",
    "Lien Holder Name",
    "Lien Holder Number",
    "Lien Date",
    "Lien Holder Address",
    "Lien Unit/Suite Number",
    "Lien City",
    "Lien County",
    "Lien State",
    "Lien Zipcode",

    "TMS ID",
    "TitleNumber",
    "Current Title State",

    "Registration Expiration Date",
    "License Plate Number",

    "Additional Information"
];

export const DELETE_TEAM_MEBR = 'Are you sure you want to delete the selected team member(s)?'
export const Individual_DELETE_TEAM_MEBR = 'Are you sure you want to delete the team member?'
export const SELECT_TEAM_MEBR = 'Please select at least one team member to delete'
export const csvcolumns = {
  ID: "Inquiry ID",
  VINNumber: "VIN",
  AccName: "Account Name",
  SubClientName: "Sub-Client Name",
  FEINNumber:'FEIN',
  PointOfContact:'Point of Contact',
  PhoneName:'Phone Number',
  Email:'Email',
  AnewAccountOwner: "Account Owner",
  State: "Processing State",
  County: "Processing County",
  ProcessType: "Process Type",
  SubmittedDate: "Created Date",
  ItemModified: "Modified Date",
  InquiryAge:'Inquiry Age',
  WorkOrderAge:'Work Order Age',
  "Status/StatusTitle": "Status",
  ETCDate: "ETC Date",
  ActionRequiredStatus: "Action Required Status",
  Year: "Year",
  Make: "Make",
  Model: "Model",
  Trim: "Trim",
  VehicleType: "Vehicle Type",
  VehicleUnitNumber: "Vehicle Unit Number",
  Color:'Color',
  OwnershipType:'Ownership Type',
  GrossVehicleWeight: "Gross Vehicle Weight",
  Lien:'Does the vehicle have a lien',
  TaxExempt:'Tax Exempt',
  Odometer:'Odometer',
  PlateType:'Plate Type',
  TMSID: "TMS ID",
  LicensePlateNumber: "License Plate Number",
  RegExpirationDate: "Registration Expiration Date",
  TrackingNumber: "Tracking Number",
  Comment:"Tracking Number Comment",
  TeamMembers: "Team Members",
  AdditionalInformation:'Additional Information',
  ArchivedDate:'Archived Date',
  CompletedDate:'Completed Date',
  CanceledDate:'Canceled Date',
  modifiedOn:'ModifiedOn',
  StatusCode:'Status Code',
 };

export enum STATUS_ENUM {
  'Submitted'= 'Submitted',
  'Completed'= 'Completed',
  'Saved' = 'Saved',
  'Copied' = 'Copied',
  'Initiated'='Initiated',
  'CORConfirmed' = 'COR Confirmed',
  'PackageDevelopment' = 'Package Development',
  'SignatureApprovals' = 'Signature Approvals',
  'UFMS' = 'UFMS',
  'Awarded' = 'Awarded'
}

export const ImportTypes = {
  INQUIRY: 'Inquiry',
  WORKORDER: 'Work Order'
}

   export const vehicleFields = [
    {key: 'EVW', label: 'EVW'},
  { key: 'Year', label: 'Year' },
  { key: 'Make', label: 'Make' },
  { key: 'Model', label: 'Model' },
  { key: 'Trim', label: 'Trim' },
  { key: 'VehicleType', label: 'VehicleType' },
  { key: 'Color', label: 'Color' },
  { key: 'OwnershipType', label: 'OwnershipType' },
   { key: 'GrossVehicleWeight', label: 'Gross Vehicle Weight' },
   { key: 'Odometer', label: 'Odometer' },
   { key: 'PlateType', label: 'Plate Type' },
   { key: 'VehicleUnitNumber', label: 'Vehicle Unit Number' },
   {key: 'LicensePlateNumber', label: 'License Plate Number' },
   {key: 'RegExpirationDate', label: 'Registration Expiration Date' },
   {key: 'TitleNumber', label: 'Title Number' },
   {key: 'Lien', label: 'Does the vehicle have a lien' },
   {key:'FuelType', label:'Fuel Type'},
   {key:'EVW', label:'EVW'},
  { key: 'LienHolderName', label: 'Lien Holder Name' },
  { key: 'LienHolderStreetName', label: 'Lien Holder Street Name' },
  { key: 'LienHolderUnit', label: 'Lien Holder Unit' },
  { key: 'LienHolderCity', label: 'Lien Holder City' },
  { key: 'LienHolderCounty', label: 'Lien Holder County' },
  { key: 'LienHolderState', label: 'Lien Holder State' },
  { key: 'LienHolderZipCode', label: 'Lien Holder Zip Code' },
  { key: 'LienHolderNumber', label: 'Lien Holder Number' },
  { key: 'LienDate', label: 'Lien Date' },
  { key: 'FuelType', label: 'Fuel Type' }

   
];

export const listviewVehicleFields=[
  { key: 'Year', label: 'Year' },
  { key: 'Make', label: 'Make' },
  { key: 'Model', label: 'Model' },
  { key: 'Trim', label: 'Trim' },
  { key: 'VehicleType', label: 'VehicleType' },
  { key: 'Color', label: 'Color' },
  { key: 'OwnershipType', label: 'OwnershipType' },
   { key: 'GrossVehicleWeight', label: 'Gross Vehicle Weight' },
   { key: 'Odometer', label: 'Odometer' },
   { key: 'PlateType', label: 'Plate Type' },
   { key: 'VehicleUnitNumber', label: 'Vehicle Unit Number' },
   {key: 'TitleNumber', label: 'Title Number' },
   {key: 'Lien', label: 'Does the vehicle have a lien' },
  ]


export const SELECT_LABEL = 'Select'
export const NA_LABEL = 'N/A'
export const NONE_LABEL = 'None'
export const YES_LABEL = 'Yes'
export const NO_LABEL = 'No'
export const ALL_SELECT_LABEL = 'All'
export const ALL_OPTION = {
  label: ALL_SELECT_LABEL,
  value: ALL_SELECT_LABEL,
}
export const SELECT_OPTION = {
  label: SELECT_LABEL,
  value: SELECT_LABEL,
}
export const NA_OPTION = {
  label: NA_LABEL,
  value: NA_LABEL,
}
export const ACTIVITY_ID = {
  SalesActionRequired: 'SALES_ACTION_REQUIRED_INQUIRY',
  SalesActionRequiredworkOrder: 'SALES_ACTION_REQUIRED_WORKORDER',
  InquiryCanceled: 'INQUIRY_CANCELED',
  WorkOrderApproved: 'WORK_ORDER_APPROVED',
  ProcessorAssigned: 'PROCESSOR_ASSIGNED',
  PacketSentToProcessor: 'PACKET_SENT_TO_PROCESSOR',
  PendingProblem: 'PENDING_PROBLEM',
  InboundActionRequired: 'INBOUND_ACTION_REQUIRED',
  ProcessCompleted: 'PROCESS_COMPLETED',
  MaterialsEnRoute: 'MATERIALS_EN_ROUTE',
  ShippedToCustomerCompleted: 'SHIPPED_TO_CUSTOMER_COMPLETED',
  WorkOrderCanceled: 'WORK_ORDER_CANCELED',
  InquirySubmitted: 'INQUIRY_SUBMITTED',
  InquiryUpdated: 'INQUIRY_UPDATED',
  WorkOrderUpdated: 'WORKORDER_UPDATED',
  InquiryResubmitted: 'INQUIRY_RESUBMITTED',
  NewWorkOrder: 'NEW_WORK_ORDER',
  ProcessStarted: 'PROCESS_STARTED',
  ProcessRestarted: 'PROCESS_RESTARTED',
  MaterialsReceived: 'MATERIALS_RECEIVED',
  AddedTeamMemberInquiry: 'ADDED_MEMBER_INQUIRY',
  RemovedTeamMemberInquiry: 'REMOVED_MEMBER_INQUIRY',
  AddedTeamMemberWorkOrder: 'ADDED_MEMBER_WORKORDER',
  RemovedTeamMemberWorkOrder: 'REMOVED_MEMBER_WORKORDER',
  FinalReview: 'FINAL_REVIEW',
  UnderReview: 'INQUIRY_UNDER_REVIEW',
  SalesRepondedInquiry: 'SALES_RESPONDED_INQUIRY',
  SalesRepondedWorkOrder: 'SALES_RESPONDED_WORKORDER',
  InboundResponded: 'INBOUND_RESPONDED',
  OutboundResponded: 'OUTBOUND_RESPONDED',
  PacketReceived: 'PACKET_RECEIVED',
  ProcessorUnassigned: 'PROCESSOR_UNASSIGNED',
  FileAdded: 'FILE_ADDED',
  FileDeleted: 'FILE_DELETED',
  ChecklistFileAdded: 'CHECKLIST_FILE_ADDED',
  ChecklistFileRemoved: 'CHECKLIST_FILE_REMOVED',
  ChecklistFileUpdated: 'CHECKLIST_FILE_UPDATED',
  FileScanned: 'FILE_SCANNED',
  TeamMemberAdded: 'TEAM_MEMBER_ADDED',
  TeamMemberRemoved: 'TEAM_MEMBER_REMOVED',
  UserManagementUserAdded: 'USER_MANAGEMENT_USER_ADDED',
  UserManagementUserRemoved: 'USER_MANAGEMENT_USER_REMOVED',
  MetadataColorAdded: 'METADATA_COLOR_ADDED',
  MetadataColorRemoved: 'METADATA_COLOR_REMOVED',
  MetadataColorUpdated: 'METADATA_COLOR_UPDATED',
  MetadataFuelTypeAdded: 'METADATA_FUELTYPE_ADDED',
  MetadataFuelTypeRemoved: 'METADATA_FUELTYPE_REMOVED',
  MetadataFuelTypeUpdated: 'METADATA_FUELTYPE_UPDATED',
  MetadataPlateTypeAdded: 'METADATA_PLATETYPE_ADDED',
  MetadataPlateTypeRemoved: 'METADATA_PLATETYPE_REMOVED',
  MetadataPlateTypeUpdated: 'METADATA_PLATETYPE_UPDATED',
  MetadataCostTypeAdded: 'METADATA_COSTTYPE_ADDED',
  MetadataCostTypeRemoved: 'METADATA_COSTTYPE_REMOVED',
  MetadataCostTypeUpdated: 'METADATA_COSTTYPE_UPDATED',
  MetadataDocumentNameAdded: 'METADATA_DOCUMENTNAME_ADDED',
  MetadataDocumentNameRemoved: 'METADATA_DOCUMENTNAME_REMOVED',
  MetadataDocumentNameUpdated: 'METADATA_DOCUMENTNAME_UPDATED',
  MetadataProcessTypeAdded: 'METADATA_PROCESSTYPE_ADDED',
  MetadataProcessTypeRemoved: 'METADATA_PROCESSTYPE_REMOVED',
  MetadataProcessTypeUpdated: 'METADATA_PROCESSTYPE_UPDATED',
  MetadataOwnershipTypeAdded: 'METADATA_OWNERSHIPTYPE_ADDED',
  MetadataOwnershipTypeRemoved: 'METADATA_OWNERSHIPTYPE_REMOVED',
  MetadataOwnershipTypeUpdated: 'METADATA_OWNERSHIPTYPE_UPDATED',
  MetadataVehicleTypeAdded: 'METADATA_VEHICLETYPE_ADDED',
  MetadataVehicleTypeRemoved: 'METADATA_VEHICLETYPE_REMOVED',
  MetadataVehicleTypeUpdated: 'METADATA_VEHICLETYPE_UPDATED',
  MetadataStateAdded: 'METADATA_STATE_ADDED',
  MetadataStateRemoved: 'METADATA_STATE_REMOVED',
  MetadataStateUpdated: 'METADATA_STATE_UPDATED',
  MetadataTooltipsAdded: 'METADATA_TOOLTIPS_ADDED',
  MetadataTooltipsRemoved: 'METADATA_TOOLTIPS_REMOVED',
  MetadataTooltipsUpdated: 'METADATA_TOOLTIPS_UPDATED',
  ReleaseNotesAdded: 'RELEASENOTES_ADDED',
  ReleaseNotesRemoved: 'RELEASENOTES_REMOVED',
  ReleaseNotesUpdated: 'RELEASENOTES_UPDATED',
  SiteFeedbackAdded: 'SITEFEEDBACK_ADDED',
  InquiryCancelRequest: 'INQUIRY_CANCEL_REQUEST',
  InquiryCancelDenied: 'INQUIRY_CANCEL_DENIED',
  WorkOrderCancelRequest: 'WORKORDER_CANCEL_REQUEST',
  WorkOrderCancelDenied: 'WORKORDER_CANCEL_DENIED',
  WorkOrderReinitiated: 'WORK_ORDER_REINITIATED',
  UserManagementUserOnboarded: 'USERMANAGEMENT_USER_ADDED',
  UserManagementUserDeleted: 'USERMANAGEMENT_USER_DELETED',
  UserManagementUserDeactivated: 'USERMANAGEMENT_USER_DEACTIVATED',
  UserManagementUserActivated: 'USERMANAGEMENT_USER_ACTIVATED',
};

export const V_TRMInquiryHistoryListColoums = {
  ID: "ID",
  VINNumber: "VINNumber",
  AccName: "AccName",
  StatusTitle: "StatusTitle",
  StatusCode: "StatusCode",
  PreviousStatusCode: "PreviousStatusCode",
  Action: "Action",
  CreatedOn: "createdOn",
  CreatedBy: "createdBy",
  Comment: "Comment",
} as const;

export const ERROR_CODES = {
  OTP_INVALID: "OTPI_4001",
  OTP_EXPIRED: "OTPE_4002",
  OTP_ATTEMPTS_EXCEEDED: "OTPTMA_4003",
  OTP_NOT_REQUESTED: "OTPNF_4004",
  USER_NOT_FOUND: "EULNF_4005",
  USER_ALREADY_EXISTS: "EURAE_4006",
  OTP_SEND_EMAIL_FAILED: "OTPFS_4007",
  MOB_EMAIL_REQ:"LOTPR_4008",
  SERVER_ERROR: "GEN_5000",
  OTP_SEND_MOBILE_FAILED: "OTPFS_4010",
  USER_EMAIL_NOT_FOUND: "EULNF_4011",
  USER_MOBILE_NOT_FOUND: "EULNF_4012",
  USER_REG_IN_PROGRESS: "URIP_4013",
  USER_REG_COMPLETED: "URCMP_4014",
  USER_RESEND_OTP: "UROTP_4015",
  USER_ACCESS_DENIED: "ACD_403",
} as const;

export const ERROR_MESSAGES: Record<string, string> = {
  [ERROR_CODES.OTP_INVALID]: "Please enter a valid OTP. OTP expires in 3 minutes.",
  [ERROR_CODES.OTP_EXPIRED]: "OTP has expired. Please request a new one.",
  [ERROR_CODES.OTP_ATTEMPTS_EXCEEDED]: "Too many invalid attempts. Please try again later.",
  [ERROR_CODES.OTP_NOT_REQUESTED]: "No OTP request found. Please request a new OTP.",
  [ERROR_CODES.USER_NOT_FOUND]: "Sorry, we can't find an account with this Email or Phone Number. Please check details and try again or sign up.",
  [ERROR_CODES.USER_ALREADY_EXISTS]: "User already exists with mobile/email address.",
  [ERROR_CODES.OTP_SEND_EMAIL_FAILED]: "Failed to send OTP to email.Please try again later.",
  [ERROR_CODES.MOB_EMAIL_REQ]: "Mobile phone number or Email is required.",
  [ERROR_CODES.SERVER_ERROR]: "Something went wrong. Please try again later.",
  [ERROR_CODES.OTP_SEND_MOBILE_FAILED]: "Failed to send OTP to mobile number.Please try again later.",
  [ERROR_CODES.USER_EMAIL_NOT_FOUND]: "Sorry, we can't find an account with this Email. Please check details and try again or sign up.",
  [ERROR_CODES.USER_MOBILE_NOT_FOUND]: "Sorry, we can't find an account with this Mobile. Please check details and try again or sign up.",
  [ERROR_CODES.USER_REG_IN_PROGRESS]: "Your registration is in progress. You will receive an OTP for verification.",
  [ERROR_CODES.USER_REG_COMPLETED]: "Thanks for registering! Please wait...You've been redirecting to your dashboard.",
  [ERROR_CODES.USER_RESEND_OTP]: "We've resent the OTP to your registered {verificationProvider}. Please enter it to continue.",
  [ERROR_CODES.USER_ACCESS_DENIED]: `Your access has been deactivated from the Anew Solutions TRM.<br/><br/>If you feel that his has happened in error, please contact our support team by phone - (877) 801-2044 or email - helpdesk@anewsolutions.com`,
};

export function getErrorMessage(code?: string): string {
  if (!code) {
    return ERROR_MESSAGES[ERROR_CODES.SERVER_ERROR];
  }

  return ERROR_MESSAGES[code] ?? code; // fallback = raw server message
};

// Web-only local-dev override - defaults to 'otp' everywhere this isn't explicitly set, so
// int/test/prod/onprem are unaffected. Never set REACT_APP_AUTH_PROVIDER=keycloak for a mobile/
// Capacitor build - keycloak-js is a browser-only OIDC client and has no native mobile path.
export const authType: AuthMode = (process.env.REACT_APP_AUTH_PROVIDER as AuthMode) || 'otp'
export const otpExpiration=180 // in seconds
export const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
};

 export const countryCodes = [
      { code: "+1", name: "US" },
      { code: "+91", name: "IN" }
];
export const indexDBNames = {
  InquiriesList : 'TRM-DB_InquiriesList',
  TRMActvityLogMetadataList : 'TRM-DB_TRMActvityLogMetadataList',
  TRMCommonMetadataList : 'TRM-DB_TRMCommonMetadataList',
  TRMNotificationsMetadataList : 'TRM-DB_TRMNotificationsMetadataList',
  TRMProcessFlowMetadataList: 'TRM-DB_TRMProcessFlowMetadataList',
  TRMStatusMetadataList : 'TRM-DB_TRMStatusMetadataList',
  TRMFormCheckListMetadata : 'TRM-DB_FormCheckListMetadata',
}

export const WeightCertificateFormName = 'Weight Certificate'
export const HVUTFormName = 'HVUT Form 2290'


export enum AccType {
  INTERNAL = 1,
  EXTERNAL = 2
}

export const colorCodes = {
  LightPurple: '#DECBE4',   
  LightGreen: '#D9F0D3',  
  LightBlue: '#A6CEE3', 
  LightRed: '#FBB4AE',
  LightBlack: '#333',
  white: '#FFFFFF',
  black: '#000000',
  black1: '#00000029',
  DarkGray: '#272A39',
  Green1: '#41A327',
  LightGray: '#E0E0E0',
  Brown: '#392727ff',
}

export const isProcessorDisabled = true
